import type { NumberOptions } from '../shared/types';

export function localizeNumber(locale: string, value: number, options?: NumberOptions): string {
	return new Intl.NumberFormat(locale, options).format(value);
}
